<template>
  <div class="ui-lightbox-wrapper" :class="layout">
    <div v-if="layout==='split-view'">
      <div class="ui-light-box-image"></div>
      <div class="ui-light-box-form">
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ['layout']
};
</script>
